import { __rest } from "tslib";
import React, { useContext } from 'react';
import s from './picture.module.css';
import WideContent from './wide-content';
import { Picture } from '../../picture/';
import { context } from '../utils';
const ModalPicture = (_a) => {
    var { header = true, footer = false } = _a, picture = __rest(_a, ["header", "footer"]);
    const { dataTest } = useContext(context);
    return (React.createElement(WideContent, { header: header, footer: footer },
        React.createElement("div", { className: s.wrapper, "data-test": dataTest && `${dataTest}-picture` },
            React.createElement(Picture, Object.assign({}, picture, { className: s.image })))));
};
export default ModalPicture;
//# sourceMappingURL=picture.js.map